import React from "react";
import { translate } from "react-i18next";
import { isHamburg } from "../../../constants";
import { Container, Content, Header, Value } from "./styles";

function TicketInfo({ t, info: { id, subject, requester, owner, ownerTeam } }) {
  return (
    <Container>
      <Content>
        <Header>
          {!isHamburg ? `${id} - ` : ""} {subject}
        </Header>
      </Content>
      <Info label={t("requester")} value={requester} />
      <Info
        label={t("owner")}
        value={
          (!!ownerTeam ? ownerTeam + " >> " : "") +
          (owner && owner.businessName)
        }
      />
    </Container>
  );
}

// extract simple component
function Info({ label, value }) {
  return (
    <Content>
      <span>{label}:</span>
      <Value>{value}</Value>
    </Content>
  );
}

export default translate("translations")(TicketInfo);
